import { ref } from 'vue';
import {
  countryCodeIsUnitedStates,
  resolveCountryCodeFromCurrentIp,
} from '@/utils/ip-country-lookup';

/** 当前出口 IP 是否判定为美国（充值隐藏现金 + MixPay；提现隐藏法币入口） */
export const usFiatDepositBlocked = ref(false);

export function resetUsFiatRestriction() {
  usFiatDepositBlocked.value = false;
}

/**
 * 美国出口 IP 不展示现金充值 / MixPay / 法币提现。仅看当前出口网络；探测失败 fail-open（仍展示）。
 * 打开弹窗时 forceRefresh，避免 VPN 切换后仍用旧缓存。
 * @param {{ forceRefresh?: boolean }} [options]
 * @returns {Promise<boolean>} true 表示应隐藏现金 / MixPay / 法币提现通道
 */
export async function resolveIsUsFiatRestricted({ forceRefresh = false } = {}) {
  const countryCode = await resolveCountryCodeFromCurrentIp({ forceRefresh }).catch(() => null);
  const blocked = countryCodeIsUnitedStates(countryCode);
  usFiatDepositBlocked.value = blocked;
  return blocked;
}
